const sax = require('sax')
const Paragraph = require('./paragraph')
const { fdxToProse, SCRATCH_TITLE_PAGE } = require('./toProse')

function fdxToScript (text, mode, callback) {
  const parser = sax.parser(true)
  const content = []
  const titlePageNodes = []
  const tagStack = []

  // NOTE: used to denote if we're currently inside an element of a specific type
  const state = {
    inContent: false,
    inTitlePage: false,
    inScriptNote: false
  }

  let dualColumnIndex = null

  parser.onclosetag = function (tagName) {
    const isParagraph = tagName === 'Paragraph'
    const isContent = tagName === 'Content'
    const isTitlePage = tagName === 'TitlePage'
    const isText = tagName === 'Text'
    const isScriptNote = tagName === 'ScriptNote'

    if (isContent) state.inContent = false
    if (isTitlePage) state.inTitlePage = false
    if (isScriptNote) state.inScriptNote = false

    const shouldExit = [
      isContent,
      isTitlePage,
      !state.inContent
    ].some(x => x)

    // exit early on state and tags we want to ignore
    if (shouldExit) return

    // here's the element we want to work with
    const el = tagStack.pop()
    const last = content[content.length - 1]
    const parent = tagStack[tagStack.length - 1]

    if (!el) return

    // mark closing script note
    if (isScriptNote && last && last.scriptNote) {
      last.scriptNote.closing = true
    }

    // only instantiate root level paragraphs
    // closing tag on paragraph when stack is at 0...
    // means we're done with this paragraph
    if (isParagraph && tagStack.length === 0 &&
      Array.isArray(el.children) && el.children.length > 0) {
      const p = new Paragraph(el)
      if (state.inTitlePage) {
        return titlePageNodes.push(p)
      }

      p.children[0].startsNewPage = el.attributes.StartsNewPage === 'Yes'

      return content.push(p)
    }

    // if we're still in a paragraph and the stack is not empty, this is a child element
    if (parent) {
      if (isParagraph && parent.name === 'DualDialogue') {
        // mark child of dual dialogue
        el.dual = true

        // this is a slightly wacky way of tracking dual dialogue columns
        if (el.attributes && el.attributes.Type === 'Character') {
          if (last.dual !== true) {
            dualColumnIndex = 0
          } else {
            if (dualColumnIndex === 0) {
              dualColumnIndex = 1
              el.dualMarker = true
            } else if (dualColumnIndex === 1) {
              // this is the beginning of another new dual dialogue block
              dualColumnIndex = 0
            }
          }
        }

        return content.push(new Paragraph(el))
      }

      if (isParagraph && parent.name === 'ScriptNote') {
        // mark script note
        el.scriptNote = {}

        // mark opening script note
        if (last && !last.scriptNote) {
          el.scriptNote.opening = true
        }

        return content.push(new Paragraph(el))
      }

      // add child text element to parent paragraph
      if (isText && parent.name === 'Paragraph') {
        if (!Array.isArray(parent.children)) parent.children = []

        // hack to ensure blank lines in script notes are captured
        if (state.inScriptNote && !el.text) {
          el.text = ['']
        }

        parent.children.push(el)
      }
    }
  }

  parser.onopentag = function (tag) {
    const isContent = tag.name === 'Content'
    const isTitlePage = tag.name === 'TitlePage'
    const isScriptNote = tag.name === 'ScriptNote'

    if (isContent) state.inContent = true
    if (isTitlePage) state.inTitlePage = true
    if (isScriptNote) state.inScriptNote = true

    const shouldExit = [
      isContent,
      isTitlePage,
      !state.inContent
    ].some(x => x)

    // exit early on state we want to ignore
    if (shouldExit) return

    // push everything that isn't TitlePage or Content root elements to the stack
    tagStack.push(tag)
  }

  parser.ontext = function (text) {
    // if there's nothing on the stack, this is junk text
    if (tagStack.length === 0) return

    // here's the element we want to work with
    const current = tagStack[tagStack.length - 1]

    // if we're not in a text element, it's junk!
    if (current.name !== 'Text') return

    // if this element doesn't have a text prop defined, define it
    if (!current.text) current.text = []

    // add text to the current element
    current.text.push(text)
  }

  parser.onend = function () {
    // Once parsing is done,
    // 1. reorder content to make sure script notes are not inside character blocks
    // 2. compose fountain text by calling `toString` on every paragraph
    // 3. do the same for title page
    // 4. join the results
    // 5. and trim trailing whitespace
    // > The End. <
    const types = ['Character', 'Dialogue', 'Parenthetical']

    const scriptNodes = content.reduce((acc, val) => {
      if (!val.scriptNote) {
        acc.push(val)
        return acc
      }

      let prev = acc[acc.length - 1]
      let charIdx

      if (prev && types.includes(prev.type)) {
        for (let i = acc.length - 1; i >= 0; --i) {
          prev = acc[i]
          if (prev.type === 'Character' && !prev.dualMarker) {
            charIdx = i
            break
          }
        }
        acc.splice(charIdx, 0, val)
      } else {
        acc.push(val)
      }

      return acc
    }, [])

    if (mode === 'FDX_TO_FOUNTAIN') {
      const script = scriptNodes.map(p => p.toString()).join('').trim()
      const title = titlePageNodes
        // we needn't pass through canned/default title page content
        .filter(p => (
          p.children[0].text &&
          !SCRATCH_TITLE_PAGE.includes(p.children[0].text[0])
        ))
        .map(p => p.toString()).join('').trim()

      const doc = title === '' ? script : title + '\n\n' + script

      return callback(null, doc)
    }

    if (mode === 'FDX_TO_PROSE') {
      return fdxToProse(scriptNodes, titlePageNodes, callback)
    }
  }

  parser.onerror = function (err) {
    throw err
  }

  try {
    parser.write(text).end()
  } catch (err) {
    callback(err)
  }
}

module.exports = fdxToScript
